const initialState = {
  portal: null,
  user: null,
  token: "",
  openUsers: [],
  openLicences: [],
  routeMessages: [],
};

export default initialState;
